<template>
  <div>
    <h2>Email Templates</h2>
    <hr>
    <button class="mylisting-button dark-button mb-4" @click="showTemplateModal()">Add Template</button>
    <div v-for="(template, index) in templates" :key="'Template'+index">
      <!-- {{ template }} -->
      <h3>Name: {{ template.name }}<span v-if="template.deactivated"> (DEACTIVATED)</span> <img src="../../../assets/img/icons/edit_icon_simple.svg" @click="showTemplateModal(template)" style="width: 15px;"></h3>
      <h5>Type: {{ template.selector1 }}</h5>
      <h5>Trigger: {{ template.type }}</h5>
      <h5 v-if="template.status">Status: {{ template.status }}</h5>
      <h5 v-if="template.selector2">Category: {{ template.selector2 }}</h5>
      <p class="">Sender Email: {{ template.from_email }}</p>
      <p class="mb-2">Subject: {{ template.subject }}</p>
      <!-- <pre>{{ template.body }}</pre> -->
      <hr>
    </div>

    <modal name="template-modal" width="90%" height="auto" :scrollable='true' class="" style="z-index: 9999;">
      <div class="p-5 field-of-fields">
        <label style="margin-top: 0;">Name</label>
        <input type="text" class="form-control" placeholder="Give the template a human readable name for your reference" v-model="name">
        <label>Subject</label>
        <input type="text" class="form-control" placeholder="" v-model="subject">
        <label>Body</label>
        <!-- <textarea rows="14" v-model="body" class="form-control"></textarea> -->
        <div class="editor">
          <!-- <Modal ref="ytmodal" @onConfirm="addCommand" /> -->
          <editor-menu-bar :editor="richEditor" v-slot="{ commands, isActive }" class="mb-1">
            <div class="menubar">
              <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.bold() }" @click.prevent="commands.bold">
                <strong>B</strong>
              </button>
              <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.italic() }" @click.prevent="commands.italic">
                <i>Italics</i>
              </button>
              <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.underline() }" @click.prevent="commands.underline">
                <u>U</u>
              </button>
              <!-- <button class="btn btn-grey btn-sm menubar__button" @click.prevent="showImagePrompt(commands.image)">
                Image
              </button> -->
              <!-- <button class="btn btn-grey btn-sm menubar__button" @click.prevent="uploadImage(commands.image)">
                Image
              </button> -->
              <!-- https://github.com/scrumpy/tiptap/issues/89 -->
              <!-- https://codesandbox.io/s/j3p0z44155 -->
              <!-- <button class="btn btn-grey btn-sm menubar__button" @click.prevent="openModal(commands.image);">
                Image
              </button> -->
              <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.paragraph() }" @click.prevent="commands.paragraph">
                p
              </button>
              <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.heading({ level: 3 }) }" @click.prevent="commands.heading({ level: 2 })">
                H1
              </button>
              <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.heading({ level: 4 }) }" @click.prevent="commands.heading({ level: 3 })">
                H2
              </button>
              <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.heading({ level: 5 }) }" @click.prevent="commands.heading({ level: 4 })">
                H3
              </button>
              <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.bullet_list() }" @click.prevent="commands.bullet_list">
                List
              </button>
              <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.ordered_list() }" @click.prevent="commands.ordered_list">
                1. 2. 3...
              </button>
              <!-- <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.blockquote() }" @click.prevent="commands.blockquote">
                ""
              </button> -->
              <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.horizontal_rule() }" @click.prevent="commands.horizontal_rule">
                ---
              </button>
              <!-- <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.undo() }" @click.prevent="commands.undo">
                Undo
              </button>
              <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.redo() }" @click.prevent="commands.redo">
                Redo
              </button> -->
            </div>
          </editor-menu-bar>
          <editor-content class="editor__content" :editor="richEditor" />
        </div>
        <p>Use [[fname]] for first name.</p>
        <label>Sender Email</label>
        <input type="text" class="form-control" placeholder="" v-model="fromEmail">
        <div class="row">
          <div class="col">
            <label>Trigger</label>
            <div class="" style="">
              <multiselect
                v-model="type"
                :options="types"
                :multiple="false"
                :searchable="false"
                :close-on-select="true"
                :show-labels="false"
                placeholder="Select Trigger"
              ></multiselect>
            </div>
          </div>
          <div class="col">
            <label>Type</label>
            <div class="" style="">
              <multiselect
                v-model="selector1"
                :options="selector1Options"
                :multiple="false"
                :searchable="false"
                :close-on-select="true"
                :show-labels="false"
                placeholder="Select Type"
              ></multiselect>
            </div>
          </div>
          <!-- <div class="col-lg-3">
            <label>Category</label>
            <div class="" style="">
              <multiselect
                v-model="selector2"
                :options="selector2Options"
                :multiple="false"
                :searchable="false"
                :close-on-select="true"
                :show-labels="false"
                placeholder="Select Category"
              ></multiselect>
            </div>
          </div> -->
          <div class="col" v-if="type == 'Status Change Notification' && selector1">
            <label>Status</label>
            <div class="" style="">
              <multiselect
                v-model="status"
                :options="statuses"
                :multiple="false"
                :searchable="false"
                :close-on-select="true"
                :show-labels="false"
                placeholder="Select Status"
              ></multiselect>
            </div>
          </div>

        </div>
        <hr>
        <div class="form-group form-check mb-1 mt-4">
          <input class="form-check-input" type="checkbox" :value="true" v-model="deactivated" style="margin-top: 4px;">
          <label class="form-check-label" style="text-align: left; cursor: pointer; margin-top: 0;" @click="deactivated = !deactivated">
            Deactivate this template
          </label>
        </div>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('template-modal')">Cancel</button>
        <button v-if="!template.id" class="mylisting-button dark-button" @click="postTemplate()" style="float: right;">Create</button>
        <button v-if="template.id" class="mylisting-button dark-button" @click="updateTemplate()" style="float: right;">Update</button>
        <p v-if="template.id" @click="$modal.show('delete-template-modal')" class="mt-1 delete-text">Delete Template</p>
      </div>
    </modal>

    <modal name="template-created-modal" width="90%" height="auto" :scrollable='true' class="" style="z-index: 9999;">
      <div class="p-5">
        <h3>Template created.</h3>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('template-created-modal')">Close</button>
      </div>
    </modal>

    <modal name="template-updated-modal" width="90%" height="auto" :scrollable='true' class="" style="z-index: 9999;">
      <div class="p-5">
        <h3>Template updated.</h3>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('template-updated-modal')">Close</button>
      </div>
    </modal>

    <modal name="delete-template-modal" width="80%" height="auto" :scrollable='true' class="" style="z-index: 9999;">
      <div class="p-5">
        <h3>Are you sure you want to delete this template?</h3>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('delete-template-modal')">Cancel</button>
        <button class="mylisting-button danger-button" @click="deleteTemplate()">Delete</button>
      </div>
    </modal>
    <modal name="template-deleted-modal" width="90%" height="auto" :scrollable='true' class="" style="z-index: 9999;">
      <div class="p-5">
        <h3>Template deleted.</h3>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('template-deleted-modal')">Close</button>
      </div>
    </modal>
  </div>
</template>

<script>
import axios from 'axios'

// https://github.com/scrumpy/tiptap/blob/master/examples/Components/Routes/Export/index.vue
// Import the editor
import { Editor, EditorContent, EditorMenuBar } from 'tiptap'
// import Icon from 'Components/Icon'
import {
  Blockquote,
  CodeBlock,
  HardBreak,
  Heading,
  HorizontalRule,
  OrderedList,
  BulletList,
  ListItem,
  TodoItem,
  TodoList,
  Bold,
  Code,
  Italic,
  Link,
  Strike,
  Underline,
  History,
  Image, // https://github.com/scrumpy/tiptap/blob/master/examples/Components/Routes/Images/index.vue
} from 'tiptap-extensions'

export default {
  components: {
    EditorContent,
    EditorMenuBar,
    // Datepicker, // https://www.npmjs.com/package/vuejs-datepicker
  },
  data() {
    return {
      templates: [],
      template: {},

      editing: false,

      status: '',
      // statuses: [],
      type: '',
      types: [
        'Status Change Notification',
        'Registration'
        // 'Status Reminder',
      ],
      selector1Options: [
        'Candidate', 'Employer',
        // 'Job'
      ],
      selector1: '',
      // selector2Options: [
      //   '',
      // ],
      selector2: '',
      subject: '',
      body: '',
      name: '',
      fromEmail: this.$store.getters.agencyFromEmail,
      // fromEmail: 'pinknannies@enginehire.io',

      richEditor: null,
      deactivated: false,
    }
  },
  computed: {
    statuses() {
      if (this.selector1 == 'Candidate') {
        return this.$store.getters.candidateStatuses
      }
      else if (this.selector1 == 'Employer') {
        return this.$store.getters.employerStatuses
      }
      else {
        return []
      }
    },
    selector2Options() {
      if (this.selector1 == 'Candidate') {
        return this.$store.getters.candidateTypes
      }
      else if (this.selector1 == 'Employer') {
        return this.$store.getters.employerTypes
      }
      else {
        return []
      }
    },
  },
  created() {
    this.getTemplates()
    // this.statuses = this.$store.getters.statuses
  },
  mounted() {
    this.richEditor = new Editor({
      // content: this.description,
      content: '',
      autoFocus: true,
      extensions: [
        new Blockquote(),
        new BulletList(),
        new CodeBlock(),
        new HardBreak(),
        new Heading({ levels: [1, 2, 3, 4, 5] }),
        new HorizontalRule(),
        new ListItem(),
        new OrderedList(),
        new TodoItem(),
        new TodoList(),
        new Link(),
        new Bold(),
        new Code(),
        new Italic(),
        new Strike(),
        new Underline(),
        new History(),
        new Image(), // https://github.com/scrumpy/tiptap/blob/master/examples/Components/Routes/Images/index.vue
      ],
      onUpdate: ({ getJSON, getHTML }) => {
        // this.json = getJSON()
        // this.html = getHTML()
        this.body = getHTML()
      },
    })
  },
  beforeDestroy() {
    this.richEditor.destroy()
  },
  methods: {
    getTemplates() {
      axios.get(`/api/emailtemplates/?agency=${this.$store.getters.agencyID}`)
        .then(res => {
          this.templates = res.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    showTemplateModal(template) {
      if (template) {
        this.template = template
        this.subject = template.subject
        this.status = template.status
        this.type = template.type
        this.name = template.name
        this.body = template.body
        this.richEditor.setContent(template.body)
        if (template.from_email) {
          this.fromEmail = template.from_email
        }
        this.selector1 = template.selector1
        this.selector2 = template.selector2
        this.deactivated = template.deactivated
      }
      else {
        this.subject = ''
        this.status = ''
        this.type = ''
        this.name = ''
        this.body = ''
        this.richEditor.setContent('')
        // this.fromEmail = this.$store.getters.agencyAdminEmail
        this.selector1 = ''
        this.selector2 = ''
        this.deactivated = false
        this.template = {}
      }
      this.$modal.show('template-modal')
    },
    postTemplate() {
      axios.post(`/api/emailtemplates/`, {
        name: this.name,
        status: this.status,
        type: this.type,
        subject: this.subject,
        body: this.body,
        from_email: this.fromEmail,
        selector1: this.selector1,
        selector2: this.selector2,
        deactivated: this.deactivated,
        agency_owner: this.$store.getters.agencyName,
        agency: this.$store.getters.agencyID,
      })
        .then(res => {
          this.getTemplates()
          this.$modal.hide('template-modal')
          this.$modal.show('template-created-modal')
        })
    },
    updateTemplate() {
      axios.patch(`/api/emailtemplates/${this.template.id}/`, {
        name: this.name,
        status: this.status,
        type: this.type,
        subject: this.subject,
        body: this.body,
        from_email: this.fromEmail,
        selector1: this.selector1,
        selector2: this.selector2,
        deactivated: this.deactivated,
        // agency_owner: this.$store.getters.agencyName,
        // agency: this.$store.getters.agencyID,
      })
        .then(res => {
          this.getTemplates()
          this.$modal.hide('template-modal')
          this.$modal.show('template-updated-modal')
        })
    },
    deleteTemplate() {
      axios.delete(`/api/emailtemplates/${this.template.id}/`)
        .then(res => {
          this.getTemplates()
          this.$modal.hide('template-modal')
          this.$modal.hide('delete-template-modal')
          this.$modal.show('template-deleted-modal')
        })
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/agents/systems/EmailTemplates.vue